module.exports = __webpack_public_path__ + "img/lock-screen.a5c1191d.png";